const lightBoxConstants = {
  LIGHT_BOX_OPEN:     'LIGHT_BOX_OPEN',
  LIGHT_BOX_CLOSE:    'LIGHT_BOX_CLOSE',
  LIGHT_BOX_NAVIGATE: 'LIGHT_BOX_NAVIGATE',
  LIGHT_BOX_LOADED:   'LIGHT_BOX_LOADED',
};

export default lightBoxConstants;